import domReady from '@wordpress/dom-ready';

domReady( () => {
	const tabs = document.querySelectorAll( '.wp-block-qasas-companion-tabs' );
	if ( tabs ) {
		Array.from( tabs )?.forEach( ( tab ) => {
			const activeClass = 'wpb-active-tab';
			const selectors = [
				'.wp-block-qasas-companion-tab-button',
				'.wp-block-qasas-companion-tab-content',
			];
			const tabButtons = tab.querySelectorAll( selectors[ 0 ] );
			const tabContents = tab.querySelectorAll( selectors[ 1 ] );
			// Get All Block Settings
			const initialTab = tab?.getAttribute( 'data-initial-tab' );
			const trigger = tab?.getAttribute( 'data-trigger' );

			// Set Initial Active Tab
			tabButtons[ initialTab - 1 ]?.classList.add( activeClass );
			tabContents[ initialTab - 1 ]?.classList.add( activeClass );

			Array.from( tabButtons )?.forEach( ( button, index ) => {
				button.addEventListener( trigger, () => {
					tabButtons.forEach( ( ele ) =>
						ele.classList.remove( activeClass )
					);
					tabContents.forEach( ( ele ) =>
						ele.classList.remove( activeClass )
					);
					button.classList.add( activeClass );
					tabContents[ index ].classList.add( activeClass );
				} );
			} );
		} );
	}
} );
